import { MENU_ORDER_TYPE } from 'helpers/enums';
import { _firestore } from '../../firebase';
import ActionTypes from './constants';

export function getHalfHalf(storeId) {
  return (dispatch) => {
    _firestore
      .collection('ProductSetup')
      .where('storeId', '==', storeId)
      .get()
      .then((querySnapshot) => {
        var dataArray = [];
        querySnapshot.forEach((doc) => {
          dataArray.push({ _id: doc.id, ...doc.data() });
        });
        dispatch(
          halfFetched(
            dataArray.length > 0
              ? dataArray[0]
              : { halfHalfs: [], halfHalfAdditionalCharges: 0 }
          )
        );
      });
  };
}

export function fetchCurrentOrder(_id, orderType) {
  return (dispatch) => {
    if (
      orderType === MENU_ORDER_TYPE.pickup ||
      orderType === MENU_ORDER_TYPE.delivery ||
      orderType === MENU_ORDER_TYPE.dinein
    ) {
      let ref = _firestore.collection('Orders').doc(_id);
      ref.onSnapshot((doc) => {
        dispatch(orderFetched({ _id: doc.id, ...doc.data() }));
      });
    } else {
      let ref = _firestore.collection('OtherDeliveries').doc(_id);
      ref.onSnapshot((doc) => {
        dispatch(orderFetched({ _id: doc.id, ...doc.data() }));
      });
    }
  };
}

export function resetCurrentOrder() {
  return (dispatch) => {
    dispatch(orderFetched({}));
  };
}

export function fetchDriverOnTheWay(_id, storeId) {
  return (dispatch) => {
    let reff = _firestore
      .collection('DriverLocations')
      .where('driverId', '==', _id)
      .where('storeId', '==', storeId);
    reff.onSnapshot((querySnapshot) => {
      var dataArray = [];
      querySnapshot.forEach((docc) => {
        dataArray.push({ _id: docc.id, ...docc.data() });
      });
      if (dataArray.length > 0) {
        dispatch(driverFetched({ ...dataArray[0] }));
      }
    });
  };
}

export function fetchOrderStatusHistory(orderId, orderType, storeId) {
  return (dispatch) => {
    if (orderType !== MENU_ORDER_TYPE.dinein) {
      let ref = _firestore
        .collection('OrderStatusHistory')
        .where('storeId', '==', storeId)
        .where('orderId', '==', orderId)
        .get();
      ref.then((querySnapshot) => {
        var dataArray = [];
        querySnapshot.forEach((doc) => {
          dataArray.push({ _id: doc.id, ...doc.data() });
        });
        dispatch(orderHistoryUpdated(dataArray));
      });
    } else {
      let ref = _firestore
        .collection('OtherDeliverieStatusHistory')
        .where('storeId', '==', storeId)
        .where('otherDeliveryId', '==', orderId)
        .get();
      ref.then((querySnapshot) => {
        var dataArray = [];
        querySnapshot.forEach((doc) => {
          dataArray.push({ _id: doc.id, ...doc.data() });
        });
        dispatch(orderHistoryUpdated(dataArray));
      });
    }
  };
}

export function fetchDriverRunOrder(_id, storeId) {
  return (dispatch) => {
    let reff = _firestore
      .collection('DriverRunOrders')
      .where('orderId', '==', _id)
      .where('storeId', '==', storeId);
    reff.get().then((querySnapshot) => {
      var dataArray = [];
      querySnapshot.forEach((docc) => {
        dataArray.push({ _id: docc.id, ...docc.data() });
      });
      if (dataArray.length > 0) {
        let ref = _firestore
          .collection('DriverRunOrders')
          .doc(dataArray[0]._id)
          .get();
        ref.then((doc) => {
          dispatch(driverRunOrderFetched({ _id: doc.id, ...doc.data() }));
        });
      }
    });
  };
}

export function getAllShifts(storeId) {
  return (dispatch) => {
    _firestore
      .collection('Shifts')
      .where('storeId', '==', storeId)
      .get()
      .then((querySnapshot) => {
        let dataArray = [];
        querySnapshot.forEach((doc) => {
          dataArray.push({ _id: doc.id, ...doc.data() });
        });
        dispatch(allShiftsFetched(dataArray));
      });
  };
}

export function getStoreInfo(storeId) {
  return (dispatch) => {
    _firestore
      .collection('Stores')
      .doc(storeId)
      .get()
      .then((doc) => {
        dispatch(storeInfoFetched({ _id: doc.id, ...doc.data() }));
      });
  };
}

function allShiftsFetched(allShifts) {
  return {
    type: ActionTypes.FetchAllShifts,
    allShifts,
  };
}

function orderHistoryUpdated(orderHistory) {
  return {
    type: ActionTypes.LoadOrderHistory,
    orderHistory,
  };
}

function driverFetched(driver) {
  return {
    type: ActionTypes.DriverFetched,
    driver,
  };
}

function orderFetched(orderObj) {
  return {
    type: ActionTypes.FetchCurrentOrder,
    orderObj,
  };
}

function driverRunOrderFetched(driverRunOrder) {
  return {
    type: ActionTypes.FetchDriverRunOrder,
    driverRunOrder,
  };
}

function halfFetched(halfHalfSetup) {
  return {
    type: ActionTypes.FetchHalfHalf,
    halfHalfSetup,
  };
}

function storeInfoFetched(storeObj) {
  let {
    _id,
    name,
    city,
    addressLocation,
    area,
    areaCode,
    country,
    countryIdentifier,
    emailAddress,
    logo,
    phoneNumber,
    state,
    street,
    timeZone,
    currency,
    connectId,
    isProductionEnv,
  } = storeObj;
  let store = {
    _id,
    name,
    addressLocation,
    area,
    areaCode,
    city,
    country,
    countryIdentifier,
    emailAddress,
    logo,
    phoneNumber,
    state,
    street,
    timeZone,
    currency,
    connectId,
    isProductionEnv,
  };
  return {
    type: ActionTypes.FetchStoreInfo,
    store,
  };
}
